import { Component } from '@angular/core';
import IPatientHasTreatment from '../../../_interfaces/IPatientHasTreatment';
import { DeleteBase } from '../../../_classes/delete-base.class';
import { SessionService } from '../../../_services/session/session.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { PatientsService } from '../../../_services/patients/patients.service';
import { Observable } from 'rxjs';
import { EResources } from '../../../_resources/EResources';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-delete-button-treatment-patient',
  imports: [TranslatePipe, ButtonModule],
  templateUrl: './delete-button-treatment-patient.component.html',
  styleUrl: './delete-button-treatment-patient.component.scss',
})
export class DeleteButtonTreatmentPatientComponent extends DeleteBase<IPatientHasTreatment> {
  constructor(
    public session: SessionService,
    public messageService: MessageService,
    public confirmationService: ConfirmationService,
    public tranlsate: TranslateService,
    public patientsService: PatientsService
  ) {
    super(session, confirmationService, messageService, tranlsate);
  }

  delete(): Observable<any> {
    return this.patientsService.removeTreatment(
      this.customers_id,
      this.payload.patients_id,
      this.payload.id
    );
  }

  getResourceName(): string {
    return EResources.TREATMENTS_PATIENTS;
  }
}
